export const breakpoints = {
  xs: 0,
  sm: 500,
  md: 500,
  mdt: 768,
  lg: 1024,
  xl: 1392,
}
